<template>
  <div v-if="teams.length > 0 && stadiums.length > 0 && listUsers.length > 0 && listSeasons.length > 0">
    <div class="md-layout">
      <div class="md-layout-item"> 
        <h3>{{$t('games.form.title')}}</h3>
      </div>
    </div>
    <div class="container md-layout">
      <div class="md-layout-item md-size-60">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>sports_soccer</md-icon>
            </div>
            <h4 class="title">{{$t('games.form.info')}}</h4>
          </md-card-header>

          <md-card-content>
            <!-- LocalId -->
            <md-field :class="{'md-error': $v.gameModel.localId.$error && $v.gameModel.localId.$invalid, 'md-valid': !$v.gameModel.localId.$error && !$v.gameModel.localId.$invalid}">
              <label for="teamLocal">{{$t('games.form.teamLocal')}}</label>
              <md-select v-model="$v.gameModel.localId.$model" name="teamLocal" id="teamLocal">
                <md-option v-for="(team, idxTeam) in teams" :key="idxTeam" :value="team.id" v-show="$v.gameModel.visitorId.$model != team.id">{{team.name}}</md-option>
              </md-select>
            </md-field>
            <!-- VisitorId -->
            <md-field :class="{'md-error': $v.gameModel.visitorId.$error && $v.gameModel.visitorId.$invalid, 'md-valid': !$v.gameModel.visitorId.$error && !$v.gameModel.visitorId.$invalid}">
              <label for="teamVisitor">{{$t('games.form.teamVisitor')}}</label>
              <md-select v-model="$v.gameModel.visitorId.$model" name="teamVisitor" id="teamVisitor">
                <md-option v-for="(team, idxTeam) in teams" :key="idxTeam" :value="team.id" v-show="$v.gameModel.localId.$model != team.id">{{team.name}}</md-option>
              </md-select>
            </md-field>
            <!-- ScheduleMatchDate -->
            <md-datepicker v-model="$v.gameModel.date.date.$model" md-immediately :class="{'md-error': $v.gameModel.date.date.$error && $v.gameModel.date.date.$invalid, 'md-valid': !$v.gameModel.date.date.$error && !$v.gameModel.date.date.$invalid}">
              <label>{{$t('games.form.matchDate')}}</label>
            </md-datepicker>
            <md-field :class="{'md-error': $v.gameModel.date.hour.$error && $v.gameModel.date.hour.$invalid, 'md-valid': !$v.gameModel.date.hour.$error && !$v.gameModel.date.hour.$invalid}">
              <label>{{$t('games.form.matchHour')}}</label>
              <md-select v-model="$v.gameModel.date.hour.$model" name="hour" id="hour">
                <md-option v-for="(hour, idxHour) in 24" :key="`idxHour-${idxHour}`" :value="timeValue(hour - 1)">{{timeValue(hour - 1)}}</md-option>
              </md-select>
            </md-field>
            <md-field :class="{'md-error': $v.gameModel.date.minutes.$error && $v.gameModel.date.minutes.$invalid, 'md-valid': !$v.gameModel.date.minutes.$error && !$v.gameModel.date.minutes.$invalid}">
              <label>{{$t('games.form.matchMinutes')}}</label>
              <md-select v-model="$v.gameModel.date.minutes.$model" name="hour" id="hour">
                <md-option v-for="(minutes, idxMinutes) in 60" :key="`idxMinutes-${idxMinutes}`" :value="timeValue(minutes - 1)">{{timeValue(minutes - 1)}}</md-option>
              </md-select>
            </md-field>
            <!-- Description -->
            <md-field :class="{'md-error': $v.gameModel.description.$error && $v.gameModel.description.$invalid, 'md-valid': !$v.gameModel.description.$error && !$v.gameModel.description.$invalid}">
              <label>{{$t('games.form.description')}}</label>
              <md-input v-model.trim="$v.gameModel.description.$model"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameModel.description.$error && $v.gameModel.description.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameModel.description.$error && !$v.gameModel.description.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
            <!-- Stadium -->
            <md-field :class="{'md-error': $v.gameModel.stadiumId.$error && $v.gameModel.stadiumId.$invalid, 'md-valid': !$v.gameModel.stadiumId.$error && !$v.gameModel.stadiumId.$invalid}">
              <label for="stadium">{{$t('games.form.stadium')}}</label>
              <md-select v-model="$v.gameModel.stadiumId.$model" name="stadium" id="stadium">
                <md-option v-for="(stadium, idxStadium) in stadiums" :key="idxStadium" :value="stadium.id">{{stadium.name}}</md-option>
              </md-select>
            </md-field>
            <!-- Season -->
            <md-field :class="{'md-error': $v.gameModel.seasonId.$error && $v.gameModel.seasonId.$invalid, 'md-valid': !$v.gameModel.seasonId.$error && !$v.gameModel.seasonId.$invalid}">
              <label for="season">{{$t('games.form.season')}}</label>
              <md-select v-model="$v.gameModel.seasonId.$model" name="season" id="season">
                <md-option v-for="season in listSeasons" :key="season.id" :value="season.id">{{season.name}}</md-option>
              </md-select>
            </md-field>
            <!-- Match day -->
            <md-field :class="{'md-error': $v.gameModel.matchday.$error && $v.gameModel.matchday.$invalid, 'md-valid': !$v.gameModel.matchday.$error && !$v.gameModel.matchday.$invalid}">
              <label>{{$t('games.form.matchday')}}</label>
              <md-input v-model.trim="$v.gameModel.matchday.$model"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameModel.matchday.$error && $v.gameModel.matchday.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameModel.matchday.$error && !$v.gameModel.matchday.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
            <!-- Picture -->
            <md-card class="md-layout-item md-size-50">
              <md-card-header-text>
                <h4>{{ $t("games.form.picture") }}</h4>
              </md-card-header-text>
              <md-card-media-actions>
                <md-card-media class="image-preview">
                  <img v-if="$v.gameModel.picture.$model != ''" :src="getUrlImage($v.gameModel.picture.$model)" alt="Live preview">
                  <img v-else src="/img/placeholder-ff21.jpg" alt="Live preview default">
                </md-card-media>

                <md-card-actions>
                  <md-button class="md-simple" :class="{'md-danger': $v.gameModel.picture.$error && $v.gameModel.picture.$invalid, 'md-success': !$v.gameModel.picture.$error && !$v.gameModel.picture.$invalid}">
                    <label for="upload-picture">
                      <md-file @md-change="uploadPicture" name="upload-picture" id="upload-picture" style="display: none"></md-file>
                      <md-icon>edit</md-icon> Editar
                    </label>
                  </md-button>
                </md-card-actions>
              </md-card-media-actions>
            </md-card>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-40">
        <!-- STREAM -->
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>sports_soccer</md-icon>
            </div>
            <h4 class="title">{{$t('games.form.stream')}}</h4>
          </md-card-header>
          <md-card-content>
            <!-- StreamingUrlLocal -->
            <md-field :class="{'md-error': $v.gameModel.streamingUrlLocal.$error && $v.gameModel.streamingUrlLocal.$invalid, 'md-valid': !$v.gameModel.streamingUrlLocal.$error && !$v.gameModel.streamingUrlLocal.$invalid}">
              <label>{{$t('games.form.streamingUrlLocal')}}</label>
              <md-input v-model.trim="$v.gameModel.streamingUrlLocal.$model"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameModel.streamingUrlLocal.$error && $v.gameModel.streamingUrlLocal.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameModel.streamingUrlLocal.$error && !$v.gameModel.streamingUrlLocal.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
            <!-- streamingUrlVisitor -->
            <md-field :class="{'md-error': $v.gameModel.streamingUrlVisitor.$error && $v.gameModel.streamingUrlVisitor.$invalid, 'md-valid': !$v.gameModel.streamingUrlVisitor.$error && !$v.gameModel.streamingUrlVisitor.$invalid}">
              <label>{{$t('games.form.streamingUrlVisitor')}}</label>
              <md-input v-model.trim="$v.gameModel.streamingUrlVisitor.$model"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameModel.streamingUrlVisitor.$error && $v.gameModel.streamingUrlVisitor.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameModel.streamingUrlVisitor.$error && !$v.gameModel.streamingUrlVisitor.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </md-card-content>
        </md-card>
        <!-- TICKETERA -->
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>sports_soccer</md-icon>
            </div>
            <h4 class="title">{{$t('games.form.ticketera')}}</h4>
          </md-card-header>
          <md-card-content>
            <!-- PaidMatch -->
            <md-switch v-model="withTicketera">{{$t('games.form.withTicketera')}}</md-switch>
            <!-- LocalTicketBuyLink -->
            <md-field :class="{'md-error': $v.gameModel.localTicketBuyLink.$error && $v.gameModel.localTicketBuyLink.$invalid, 'md-valid': !$v.gameModel.localTicketBuyLink.$error && !$v.gameModel.localTicketBuyLink.$invalid}">
              <label>{{$t('games.form.localTicketBuyLink')}}</label>
              <md-input :disabled="!withTicketera" v-model.trim="$v.gameModel.localTicketBuyLink.$model"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameModel.localTicketBuyLink.$error && $v.gameModel.localTicketBuyLink.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameModel.localTicketBuyLink.$error && !$v.gameModel.localTicketBuyLink.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
            <!-- VisitorTicketBuyLink -->
            <md-field :class="{'md-error': $v.gameModel.visitorTicketBuyLink.$error && $v.gameModel.visitorTicketBuyLink.$invalid, 'md-valid': !$v.gameModel.visitorTicketBuyLink.$error && !$v.gameModel.visitorTicketBuyLink.$invalid}">
              <label>{{$t('games.form.visitorTicketBuyLink')}}</label>
              <md-input :disabled="!withTicketera" v-model.trim="$v.gameModel.visitorTicketBuyLink.$model"></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameModel.visitorTicketBuyLink.$error && $v.gameModel.visitorTicketBuyLink.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameModel.visitorTicketBuyLink.$error && !$v.gameModel.visitorTicketBuyLink.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </md-card-content>
        </md-card>
        <!-- ADMIN -->
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>sports_soccer</md-icon>
            </div>
            <h4 class="title">{{$t('games.form.admin')}}</h4>
          </md-card-header>
          <md-card-content>
            <!-- Admins -->
            <md-field :class="{'md-error': $v.gameModel.admins.$error && $v.gameModel.admins.$invalid, 'md-valid': !$v.gameModel.admins.$error && !$v.gameModel.admins.$invalid}">
              <label for="admins">{{$t('games.form.admins')}}</label>
              <md-select v-model="$v.gameModel.admins.$model" name="admins" id="admins" multiple>
                <md-option v-for="(user, idxUser) in listUsers" :value="user.id" :key="idxUser">{{user.firstName}} {{user.lastName}}</md-option>
              </md-select>
              <slide-y-down-transition>
                <md-icon class="error" v-show="$v.gameModel.admins.$error && $v.gameModel.admins.$invalid">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="!$v.gameModel.admins.$error && !$v.gameModel.admins.$invalid">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item">
        <md-button @click="createGame" class="md-info md-block" :disabled="loading">
          {{$t('games.form.create')}}
        </md-button>
      </div> 
    </div>
  </div>
</template>

<script>
import storage from "@/plugins/azure-storage";
import { required, email, sameAs, numeric } from 'vuelidate/lib/validators';
import { SlideYDownTransition } from "vue2-transitions";
import { mapState } from 'vuex';
import moment from 'moment';

window.moment = moment;

export default {
  components: {
    SlideYDownTransition
  },
  computed: {
    ...mapState({
      teams: state => state.StuffModule.teams,
      stadiums: state => state.StuffModule.stadiums,
      listUsers: state => state.SecurityModule.listUsers,
      listSeasons: state => state.StuffModule.seasons
    }),
    scheduledMatchDate() {
      return `${moment(this.gameModel.date.date).format('YYYY-MM-DD')}T${this.gameModel.date.hour}:${this.gameModel.date.minutes}:00.000`
    }
  },
  data() {
    return {
      loading: false,
      gameModel: {
        localId: '',
        visitorId: '',
        // scheduledMatchDate: '',
        date: {
          date: null,
          hour: '',
          minutes: ''
        },
        picture: '',
        description: '',
        stadiumId: '',
        seasonId: '',
        matchday: '',
        streamingUrlLocal: '',
        streamingUrlVisitor: '',
        localTicketBuyLink: '',
        visitorTicketBuyLink: '',
        admins: []
      },
      withTicketera: false
    }
  },
  mounted() {
    if (this.teams.length == 0) this.$store.dispatch('teamsGet')
    if (this.stadiums.length == 0) this.$store.dispatch('getStadiums')
    if (this.listUsers.length == 0) this.$store.dispatch('usersGet')
    if (this.listSeasons.length == 0) this.$store.dispatch('seasonsGet')
  },
  beforeMount() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy'
  },
  methods: {
    async createGame() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        
        let model = this.gameModel
        model.scheduledMatchDate = `${moment(this.gameModel.date.date).format('YYYY-MM-DD')}T${this.gameModel.date.hour}:${this.gameModel.date.minutes}:00.000`
        model.visitorPaid = this.withTicketera
        model.localPaid = this.withTicketera
        
        const response = await this.$store.dispatch("create", model);
        if (response != undefined) {
          this.$notify({
            message: this.$t(`notifications.game.create`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success'
          })
          this.$router.push("/list/games");
        } else {
          this.$store.dispatch("openModalError")
        }
        this.loading = false;
        return;
      } else {
        return;
      }
    },
    async uploadPicture(FileList) {
      const file = FileList[0];
      this.loading = true;
      const fileName = await storage.updateFile({
        file,
        container: process.env.VUE_APP_CDN_CONTAINER_GAME_PICTURES
      });

      this.gameModel.picture = fileName;
      this.$v.gameModel.picture.$touch();
      this.loading = false;

      return;
    },
    timeValue(str) {
      if (Number(str) >= 0 && Number(str) <= 9) {
        return `0${str}`;
      } else {
        return str;
      }
    },
    getUrlImage(path) {
      return `${process.env.VUE_APP_CDN_URL_GAME_PICTURES}${path}`
    }
  },
  validations: {
    gameModel: {
      localId: {
        required
      },
      visitorId: {
        required
      },
      date: {
        date: {
          required
        },
        hour: {
          required
        },
        minutes: {
          required
        }
      },
      description: {
        required
      },
      stadiumId: {
        required
      },
      seasonId: {
        required
      },
      matchday: {
        required,
        numeric
      },
      picture: {
        required
      },
      streamingUrlLocal: {},
      streamingUrlVisitor: {},
      localTicketBuyLink: {},
      visitorTicketBuyLink: {},
      admins: {}
    }
  }
}
</script>
